import Tooltip from "../tooltip";
import FormSystemError from "../../../utils/form-error-constants";

class ChangePassword {
    constructor() {
        this.formErrorConstants = new FormSystemError('#changePasswordForm');
        this.formErrorConstants.init();
    }

    init() {
        let formSystemError = new FormSystemError();
        formSystemError.init();

        this.submitChangePassword();
    }

    submitChangePassword() {
        let tooltip = new Tooltip();
        tooltip.init();
        let form = $('#changePasswordForm');

        form.on('click', '.check-form', {'form': form},  event => {
            let allowSendForm = true;
            event.preventDefault();
            let form = event.data.form;
            this.formErrorConstants.removeErrors(form);
            this.formErrorConstants.removeDataError(form);
            form.find('input:required, select:required').not(':button, :hidden').each(function (i, element) {
                let errorMessage = $(element).data('error-message');
                if (errorMessage) {
                    let value = $(element).val();
                    if (!value || value.length === 0) {
                        allowSendForm = false;
                        $(element).attr('data-error', errorMessage);
                    }
                }
            });

            let newPassword = $("#newPassword");
            let newPasswordMinLength = newPassword.attr("data-minlength");

            if (newPassword.val() && newPassword.val().length < newPasswordMinLength) {
                newPassword.attr('data-error', 'newpassworderror');
                allowSendForm = false;
            }

            if (!this.isPasswordStrong(newPassword.val())) {
                newPassword.attr('data-error', 'newpassworderror');
                allowSendForm = false;
            }

            if (!this.isPasswordConfirmed()) {
                $('#newPasswordConfirm').attr('data-error', 'passworderror');
                allowSendForm = false;
            }

            if (allowSendForm) {
                form.submit();
            } else {
                this.formErrorConstants.init();
            }
        });
    }

    isPasswordConfirmed() {
        return $("#newPassword").val() === $("#newPasswordConfirm").val();
    }

    isPasswordStrong(newPassword) {
        return /\d/.test(newPassword) && isNaN(newPassword) && /[a-zA-Z]/.test(newPassword);
    }
}

$(document).ready(function () {
    let changePassword = new ChangePassword();
    changePassword.init();
});
